/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>门店管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="menberList"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="index" width="60" label="序号">
      </el-table-column>
      <el-table-column
        prop="avatarUrl"
        label="门店图片"
        width="150"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.imageUrl"
            alt="门店图片"
            style="max-width: 100%; max-height: 80px"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="门店名称"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="phone"
        label="云值守（在线/不在线）"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.expireState == 1">
            <el-switch
              v-model="scope.row.value"
              @change="changeValue(scope.row)"
            >
            </el-switch>
          </div>
          <p v-else>已过期</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="门店地址"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="80">
        <template slot-scope="scope">
          <el-button size="mini" @click="open(scope.row)" type="primary"
            >点击开门</el-button
          >
          <!-- <el-button
            size="mini"
            type="danger"
            @click="deleteUser(scope.$index, scope.row)"
            >退款</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination> -->
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="50%"
      @click="closeDialog('editForm')"
    >
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="20">
            <el-form-item label="用户名">
              <el-input
                size="small"
                v-model="editForm.nickName"
                auto-complete="off"
                placeholder="用户名"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input
                size="small"
                v-model="editForm.phone"
                auto-complete="off"
                placeholder="手机号"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户余额">
              <el-input
                size="small"
                v-model="editForm.balance"
                auto-complete="off"
                placeholder="用户余额"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户积分">
              <el-input
                size="small"
                v-model="editForm.vipPoints"
                auto-complete="off"
                placeholder="用户积分"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户标签">
              <div>
                <el-checkbox-group size="medium" v-model="editForm.tags">
                  <el-checkbox-button
                    v-for="item in colorRange"
                    :label="item.text"
                    :key="item.value"
                    >{{ item.text }}</el-checkbox-button
                  >
                </el-checkbox-group>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('edit')">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { OrderList, OrderRefund, OrderDelete  } from "../../api/payMG";
import Pagination from "../../components/Pagination";

import {
  getGoodsList,
  getGoodsTypeList,
  getMemberList,
  editMemberInfo,
  getStore, //获取门店列表
  changeStoreStatus, //改变门店状态
  openDoor, //开门
} from "@/api/api.js";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "会员用户设置",
      date: "",
      year: "",
      month: "",
      day: "",
      goodsStatus: "", //商品类型
      //
      colorRange: [
        "lanse",
        "lvse",
        "zise",
        "huangse",
        // {
        //   text: "蓝色",
        //   value: "primary",
        // },
        // {
        //   text: "绿色",
        //   value: "success",
        // },
        // {
        //   text: "紫色",
        //   value: "royal",
        // },
        // {
        //   text: "黄色",
        //   value: "warning",
        // },
        // {
        //   text: "红色",
        //   value: "error",
        // },
      ],
      payway: [
        { key: "全部订单", value: 0 },
        { key: "已完成订单", value: 1 },
        { key: "已取消订单", value: 2 },
        { key: "已退款订单", value: 3 },
      ],
      goodsTypeList: [], //商品类型列表
      orderList: "", //订单列表
      phone: "", //会员手机号
      goodsList: [], //商品列表
      editForm: {
        tags: [],
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: "",
        orderNo: "",
        transId: "",
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      menberList:[],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    if (!localStorage.getItem("storeLitst"))
      this.getData();
    else {
      this.menberList =  JSON.parse(localStorage.getItem("storeLitst"));

    }
    // this.getdata(this.formInline);
    // this.getGoodsType();//获取商品类型列表
    // this.getData(); //获取商品列表
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //获取商品类型列表
    getGoodsType() {
      getGoodsTypeList().then((res) => {
        //改变数组里元素的某个属性
        res.data.forEach((item) => {
          item.key = item.name;
          item.value = item.id;
        });
        //在数组开头添加一个元素
        res.data.unshift({ key: "所有", value: "" });
        this.goodsTypeList = res.data;
      });
    },
    //获取会员列表
    getData() {
      this.loading = true;
      getStore().then((res) => {
        //改变数组里元素的某个属性
        res.data.forEach((item) => {
          item.value = item.storeState == 0 ? false : true;
        });
        this.menberList = res.data;
        this.loading = false;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.limit;
        this.pageparm.total = res.data.total;
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = 10;
      // this.getdata(this.formInline)
      this.getData();
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      this.getData();
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = row;
      console.log(index, row, "333333");
    },
    // 编辑、增加页面保存方法
    submitForm() {
      console.log(11111, this.editForm);
      editMemberInfo(this.editForm).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.editFormVisible = false;
          this.getData();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });

      // editMemberInfo(this.editForm).then((res)=>{

      // })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("支付配置信息删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //改变门店状态
    changeValue(row) {
      //发请求改变门店状态
      changeStoreStatus({
        isOpen: row.value,
        storeId: row.id,
      }).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: res.data,
          });
          this.getData();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    //开门
    open(row){
        openDoor({
            storeId: row.id,
        }).then((res) => {
            if (res.code == 0) {
            this.$message({
                type: "success",
                message: "开门成功！",
            });
            this.getData();
            } else {
            this.$message({
                type: "error",
                message: res.msg,
            });
            }
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/charts/stores.vue